export default "__VITE_ASSET__DLJ0jmIp__"